import React from 'react'
import { WorkModel } from '@Entities/work/work'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'

interface SongwriterSearchedWorkHeaderProps {
    work: WorkModel
}

const SongwriterSearchedWorkHeader = ({ work }: SongwriterSearchedWorkHeaderProps) => (
    <ViewWorkHeader work={work} backText="< Back to search results" />
)

export default SongwriterSearchedWorkHeader
